import Icon from '@mdi/react'
import styled from 'styled-components'
import theme from 'theme_'

export const SubscriptionTableOuterContainer = styled.div`
  width: 100%;
  animation: ${theme.animations.fadeIn} 0.3s ease;
`

export const SubscriptionTableInnerContainer = styled.div`
  box-shadow: 10px 10px 10px rgb(0 0 0 / 1%);
  margin-bottom: 10px;

  @media ${theme.devices.tablet} {
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
  }
`

export const SubscriptionInfoIcon = styled(Icon)<{
  $colorful: boolean
}>`
  height: 24px;
  color: ${({ $colorful }) =>
    $colorful ? theme.colors.horizonOrange : theme.colors.darkeyGrey};
`

export const SubscriptionUnlimitedText = styled.div<{
  colorful: boolean
}>`
  height: 24px;
  color: ${({ colorful }) =>
    colorful ? theme.colors.horizonOrange : theme.colors.black};
`

export const SubscriptionMinusIcon = styled(Icon)`
  height: 24px;
  color: ${theme.colors.pelicanGrey};
`

export const SubscriptionCheckIcon = styled(Icon)<{
  $colorful: boolean
}>`
  height: 24px;
  color: ${({ $colorful }) =>
    $colorful ? theme.colors.horizonOrange : theme.colors.otterWarmBlack};
`

export const SubscriptionTableTitle = styled.h2`
  height: 24px;
`
